<div class="d-flex flex-column gap-3">
  <span class="fw-medium">{{
    "app.pageId.void-claim.description" | translate
  }}</span>

  <radio-component
    [config]="radiosConfig()"
    (onRadioOptionSelected)="onRadioOptionSelected($event)"
  />
</div>
